// extracted by mini-css-extract-plugin
export default {"styleLabeled1":"StyleLabeledOne_styleLabeled1__ZDvhQ","styleLabel2":"StyleLabeledOne_styleLabel2__aeOKH"};